import { Fragment } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import Grid from "@mui/material/Grid";

import logo from "assets/logo.png";
import BackgroundImage from "assets/TilaaTaksi_099.jpg";
import Prices from "./Prices";
import ViewContainer from "components/ViewContainer/ViewContainer";

const useStyles = makeStyles((_theme) => ({
  navContainer: {},
  logo: {
    height: 50,
    margin: 24,
  },
  logoMobile: {
    height: 50,
    padding: 8,
  },
  introContainer: {
    minHeight: "100vh",
    paddingTop: 32,
    paddingBottom: 32,
    backgroundColor: "rgba(0,0,0,0.5)",
    backgroundImage:
      " linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(" +
      BackgroundImage +
      ")",
    backgroundSize: "cover",
    backgroundPosition: "bottom",
  },
}));

const Legal = (_props) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Grid
        container
        direction="row"
        className={classes.navContainer}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid size={12}>
          <img src={logo} alt="logo" className={classes.logo} />
        </Grid>
      </Grid>

      <Grid
        container
        className={classes.introContainer}
        sx={{ alignContent: "center", alignItems: "center" }}
      >
        <Grid className={classes.introItem} size={{ xs: 12 }}>
          <ViewContainer>
            <Routes>
              <Route path="prices" element={<Prices />} />
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </ViewContainer>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Legal;
